<section class="flex align-items-center mr-xxs">
  <lib-experian-logo-svg [isMobile]="innerWidth < 768" class="flex mr-xxs"></lib-experian-logo-svg>
  @if (headerFooterVariant === 'default') {
    <span class="header-logo__title">{{ title }}</span>
  }
</section>
